import { Typography } from "@mui/material";
import React from "react";
import "./analytics/analytics.css";
const Footer = () => {
  return (
    <footer
      className="main-footer"
      style={{
        height: "60px",
        flexShrink: "0",
        padding: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 0px 8px -2px rgba(59, 59, 59, 0.08)",
      }}
    >
      <div>
        {/* <Typography
        className="bodyB2RegularText"
        sx={{ fontSize: "12px", color: "rgba(10, 9, 11, 1)" }}
      >
        &copy; 2024{" "}
        <a
          target="_blank"
          href="https://www.boxpay.tech"
          style={{
            textDecoration: "underline",
            color: "var(--Global-Purple-900, #403E9F)",
            fontWeight: "500",
            lineHeight: "20px",
            letterSpacing: "-0.05px",
          }}
        >
          BoxPay
        </a>
        . All rights reserved.
      </Typography> */}
      </div>
      <div
        style={{
          display: "flex",
          gap: "24px",

          fontFamily: "Poppins",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "18px",
        }}
      >
        <a
          target="_blank"
          href="https://www.boxpay.tech/terms-conditions"
          style={{
            textDecorationLine: "underline",
            color: "var(--Global-Neutral-Grey-1300, #0A090B)",
          }}
        >
          Terms
        </a>
        <a
          target="_blank"
          href="https://www.boxpay.tech/privacy-policy"
          style={{
            textDecorationLine: "underline",
            color: "var(--Global-Neutral-Grey-1300, #0A090B)",
          }}
        >
          Privacy
        </a>
      </div>
    </footer>
  );
};

export default Footer;
